export default "__VITE_ASSET__Ca8k3tny__"